import { Resource } from 'react-admin';
import PatronPoints from './patron_points_stores'
import NRS from './nrs_stores'
import StoreStatus from './store_status_log';
// import DailyPatronPoints from './daily_patron_points';
// import { registrationConf } from './PatronPointsRegistrationWizard';

const OnpointResources = [
    <Resource name='onpoint_chain_to_chain_mapping' />,
    <Resource name='onpoint_patron_points_stores' {...PatronPoints} />,
    <Resource name='onpoint_patron_point_store_migration_summary'/>,
    <Resource name='onpoint_patron_points_tc_store_pos_type_day_summary'/>,
    <Resource name='onpoint_master_customer_notes' />,
    <Resource name='onpoint_patron_points_store_notes' />,
    <Resource name='onpoint_nrs_stores' {...NRS} />,
    <Resource name="onpoint_store_status_log" {...StoreStatus} />,
    <Resource name='patron_points_onpoint_participant_schedules'/>
];

export default OnpointResources;